/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pro_User_Include_TitleInputs */

const en_pro_user_include_title = /** @type {(inputs: Pro_User_Include_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro users include those who:`)
};

const ar_pro_user_include_title = /** @type {(inputs: Pro_User_Include_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احترافي يشمل المستخدمون أولئك الذين:`)
};

const de_pro_user_include_title = /** @type {(inputs: Pro_User_Include_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro zu den Nutzern gehören diejenigen, die:`)
};

const es_pro_user_include_title = /** @type {(inputs: Pro_User_Include_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los usuarios Pro incluyen a aquellos que:`)
};

const fr_pro_user_include_title = /** @type {(inputs: Pro_User_Include_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les utilisateurs Pro sont ceux qui :`)
};

const it_pro_user_include_title = /** @type {(inputs: Pro_User_Include_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gli utenti Pro  includono coloro che:`)
};

const ja_pro_user_include_title = /** @type {(inputs: Pro_User_Include_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proユーザーには次のような人が含まれます。`)
};

const ko_pro_user_include_title = /** @type {(inputs: Pro_User_Include_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro 사용자는 다음을 포함해요.`)
};

const pt_br_pro_user_include_title = /** @type {(inputs: Pro_User_Include_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os usuários Pro incluem aqueles que:`)
};

const ru_pro_user_include_title = /** @type {(inputs: Pro_User_Include_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пользователи Pro включают тех, кто:`)
};

const th_pro_user_include_title = /** @type {(inputs: Pro_User_Include_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้ใช้โปร ได้แก่ผู้ที่:`)
};

const tr_pro_user_include_title = /** @type {(inputs: Pro_User_Include_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro Kullanıcılar arasında şunlar yer almaktadır:`)
};

const zh_cn_pro_user_include_title = /** @type {(inputs: Pro_User_Include_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专业版用户包含：`)
};

const zh_tw_pro_user_include_title = /** @type {(inputs: Pro_User_Include_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`專業版用戶包含：`)
};

/**
* | output |
* | --- |
* | "Pro users include those who:" |
*
* @param {Pro_User_Include_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const pro_user_include_title = /** @type {((inputs?: Pro_User_Include_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pro_User_Include_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pro_user_include_title(inputs)
	if (locale === "ar") return ar_pro_user_include_title(inputs)
	if (locale === "de") return de_pro_user_include_title(inputs)
	if (locale === "es") return es_pro_user_include_title(inputs)
	if (locale === "fr") return fr_pro_user_include_title(inputs)
	if (locale === "it") return it_pro_user_include_title(inputs)
	if (locale === "ja") return ja_pro_user_include_title(inputs)
	if (locale === "ko") return ko_pro_user_include_title(inputs)
	if (locale === "pt_br") return pt_br_pro_user_include_title(inputs)
	if (locale === "ru") return ru_pro_user_include_title(inputs)
	if (locale === "th") return th_pro_user_include_title(inputs)
	if (locale === "tr") return tr_pro_user_include_title(inputs)
	if (locale === "zh_cn") return zh_cn_pro_user_include_title(inputs)
	return zh_tw_pro_user_include_title(inputs)
});